<svelte:options tag="w-card" />

<script>
    import Utils from "../utils";

    export let nomination = {};

    let url = "";

    $: defaultImage =
        process.env === "production"
            ? Utils.getImage(nomination).includes("https://images.produ.com/")
                ? Utils.getImage(nomination)
                : Utils.getImage(nomination).replace(".", myurl)
            : Utils.getImage(nomination);

    $: url = process.env === 'production'
        ?`//${window.location.host}/ganadores/${nomination._id}`
        :`//localhost:34497/?w=${nomination._id}`;

</script>

<div class="col-sm-6 col-md-3">
    <a target="_self" href={url}>
        <div class="card-fiap">
            <div class="title">
                <h3>{nomination.medal}</h3>
                <h4>{nomination.categoryName}</h4>
            </div>
            <img src={defaultImage} alt="" />
            <div class="info">
                <h4>{nomination.name}</h4>
                {#if nomination.agencyName}
                    <h6><strong>Agencia: </strong>{nomination.agencyName}</h6>
                {/if}
                <h6><strong>Cliente: </strong>{nomination.clientName}</h6>
                {#if nomination.subCategory}
                    {#if nomination.medal != "Gran Sol" && nomination.medal != "Mención Especial"}
                        <h6>
                            <strong>Categoría: </strong>{nomination.subCategory}
                        </h6>
                    {/if}
                {/if}
            </div>
        </div>
    </a>
</div>
